import WidgetContext from 'embed_v2/components/Context'
import { memo } from 'preact/compat'
import { useEffect, useRef, useContext } from 'preact/hooks'
import { getStylesFn } from 'core/helpers/styles'
import { ElementEmbedCodeOptions } from 'core/types/element/element_embed_code'
import optionsPropTypes from 'PropsSpec'

const extractStyles = getStylesFn(['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'])

type Props = {
  options: ElementEmbedCodeOptions
}

const EmbedCode = (props: Props) => {
  const { api, version } = useContext(WidgetContext)
  const { options } = props

  const divRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    switch (options.type) {
      case 'widget': {
        const widgetCid = options.embed_widget?.cid

        if (widgetCid) {
          const refClassName = `wf_embed_code_widget_${widgetCid}`
          if (divRef.current) {
            divRef.current.className += refClassName
          }

          api.context.push({
            id: widgetCid,
            targetElement: `.${refClassName}`,
            embedVersion: {
              id: version.id
            }
          })
        }
        break
      }
      case 'custom':
        if (options.code?.length) {
          const fragment = document.createRange().createContextualFragment(options.code)
          if (divRef.current) {
            divRef.current.append(fragment)
          }
        }
        break
      default:
        break
    }
  }, [options.type])

  const styles = extractStyles(options)

  return (
    <div style={styles} className="wf_reset wf_embed_code_wrapper">
      <div ref={divRef} />
    </div>
  )
}

EmbedCode.propTypes = {
  options: optionsPropTypes('embed_code')
}

export default memo(EmbedCode)
